import { render, staticRenderFns } from "./BottomSeo.vue?vue&type=template&id=18f212ac"
import script from "./BottomSeo.vue?vue&type=script&lang=js"
export * from "./BottomSeo.vue?vue&type=script&lang=js"
import style0 from "./BottomSeo.vue?vue&type=style&index=0&id=18f212ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/app/components/ui/button/c-btn.vue').default})
